import * as React from 'react';
import { IconProps } from '../types';

const IcCashierClear = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fill={props?.fill ?? '#232F3E'}
      fillRule="evenodd"
      d="M8.513 3.8h12.681c.61.003 1.196.257 1.628.708.431.451.675 1.062.678 1.7V18.592a2.474 2.474 0 0 1-.678 1.7 2.268 2.268 0 0 1-1.628.708H8.513c-.329 0-.654-.074-.953-.216-.3-.142-.567-.35-.783-.608a.86.86 0 0 1-.086-.124l-4.554-7.177a.892.892 0 0 1 0-.95L6.71 4.714a.857.857 0 0 1 .067-.092c.217-.258.484-.465.783-.607.299-.141.623-.215.952-.215Zm.001 1.72a.637.637 0 0 0-.466.202L3.811 12.4l4.24 6.681a.658.658 0 0 0 .463.199h12.674a.655.655 0 0 0 .469-.205.714.714 0 0 0 .196-.49V6.215a.714.714 0 0 0-.196-.49.656.656 0 0 0-.469-.204H8.514Z"
      clipRule="evenodd"
    />
    <path
      fill={props?.fill ?? '#232F3E'}
      fillRule="evenodd"
      d="M18.951 8.349a.85.85 0 0 1 0 1.2l-6.901 6.902a.85.85 0 0 1-1.201-1.201l6.901-6.901a.85.85 0 0 1 1.201 0Z"
      clipRule="evenodd"
    />
    <path
      fill={props?.fill ?? '#232F3E'}
      fillRule="evenodd"
      d="M10.849 8.349a.85.85 0 0 1 1.2 0l6.902 6.901a.85.85 0 0 1-1.201 1.201L10.849 9.55a.85.85 0 0 1 0-1.201Z"
      clipRule="evenodd"
    />
  </svg>
);

export default IcCashierClear;
